<template>
  <nav class="ui labeled icon left inline vertical sidebar menu" role="navigation" aria-label="Menú lateral">
    <!-- Home/Title -->
    <a 
      href="/" 
      class="item"
      :class="{ active: isActiveRoute('/') }"
      @click="handleNavigation($event, '/')"
    >
      <i class="home icon" aria-hidden="true"></i>
      {{ titulo }}
    </a>

    <!-- Dynamic menu items -->
    <template v-for="menu in filteredMenus" :key="menu.id">
      <a 
        :href="menu.href"
        class="item"
        :class="{ active: menu.activa }"
        @click="handleNavigation($event, menu.href)"
      >
        <i :class="menu.icon" aria-hidden="true"></i>
        {{ menu.opcion }}
      </a>
    </template>
  </nav>
</template>

<script>
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { EventBus } from '@/lib/eventbus.js'


export default {
  name: 'MenuComponent',
  props: {
    activo: {
      type: String,
      default: ''
    },
    titulo: {
      type: String,
      default: 'Inicio'
    },
    rol: {
      type: String,
      default: 'user',
      validator: (value) => ['admin', 'caja', 'user'].includes(value)
    }
  },
  
  setup(props) {
    
    // Base menu configuration
    const baseMenus = ref([
      {
        id: 1,
        opcion: 'Facturas',
        icon: 'shopping cart icon',
        href: '/facturasm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 2,
        opcion: 'Albaranes',
        icon: 'dolly icon',
        href: '/albaranesm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 3,
        opcion: 'Presupuestos',
        icon: 'clipboard list icon',
        href: '/presupuestosm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 4,
        opcion: 'Clientes',
        icon: 'users icon',
        href: '/clientesm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 5,
        opcion: 'Entregas',
        icon: 'money bill alternate outline icon',
        href: '/entregasm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 6,
        opcion: 'Caja',
        icon: 'euro sign icon',
        href: '/cajasm',
        roles: ['admin', 'caja']
      },
      {
        id: 7,
        opcion: 'Articulos',
        icon: 'barcode icon',
        href: '/articulosm',
        roles: ['admin', 'caja', 'user']
      },
      {
        id: 8,
        opcion: 'Familias',
        icon: 'child icon',
        href: '/familiasm',
        roles: ['admin', 'caja', 'user']
      },
      // {
      //   id: 9,
      //   opcion: 'Verifactu',
      //   icon: 'child icon',
      //   href: '/familiasm',
      //   roles: ['admin', 'caja', 'user']
      // }
    ])

    // Computed property to filter menus based on user role
    const filteredMenus = computed(() => {
      return baseMenus.value
        .filter(menu => menu.roles.includes(props.rol))
        .map(menu => ({
          ...menu,
          activa: isMenuActive(menu.opcion)
        }))
    })

    // console.log('----- Modo ------', this.$appConfig.showDevOptions);

    // Methods
    const isMenuActive = (opcion) => {
      return opcion === props.activo
    }

    const isActiveRoute = (path) => {
      return window.location.pathname === path
    }

    const handleNavigation = (event, href) => {
      event.preventDefault()
      
      // Get section name from href for loading message
      const section = href.split('/').pop() || 'default'
      const message = getLoadingMessage(section)
      
      // console.log('🔄 Navegando a:', href, 'Sección:', section)
      
      // Siempre mostrar loading (sin condiciones)
      EventBus.emit('loading:show', { 
        section: section,
        message: message
      })
      
      // Close sidebar
      if (window.jQuery) {
        window.jQuery('.ui.labeled.icon.sidebar').sidebar('hide')
      }
      
      // Navigate immediately (el loading se ocultará automáticamente)
      setTimeout(() => {
        // console.log('🔄 Navegando ahora...')
        window.location.href = href
      }, 150)
    }

    const getLoadingMessage = (section) => {
      const messages = {
        'facturasm': 'Cargando facturas...',
        'albaranesm': 'Cargando albaranes...',
        'presupuestosm': 'Cargando presupuestos...',
        'clientesm': 'Cargando clientes...',
        'entregasm': 'Cargando entregas...',
        'articulosm': 'Cargando artículos...',
        'familiasm': 'Cargando familias...',
        'cajasm': 'Cargando caja...'
      }
      return messages[section] || 'Cargando...'
    }

    // Event bus handlers
    const handleMenuMessage = (data) => {
      console.log('Mensaje recibido en menuvue:', data)
    }

    const handleRemoveLoading = (data) => {
      // console.log('Quitando loading:', data)
    }

    // Lifecycle hooks
    onMounted(() => {
      EventBus.on('mensajemenu', handleMenuMessage)
      EventBus.on('quitarloading', handleRemoveLoading)
    })

    onUnmounted(() => {
      EventBus.off('mensajemenu', handleMenuMessage)
      EventBus.off('quitarloading', handleRemoveLoading)
    })

    return {
      filteredMenus,
      isActiveRoute,
      handleNavigation
    }
  }
}
</script>

<style scoped>
.sidebar.menu {
  /* Ensure proper z-index for sidebar */
  z-index: 1001;
}

.item {
  /* Improve touch targets */
  min-height: 44px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease;
}

.item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.item.active {
  background-color: rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.icon {
  margin-right: 0.5em !important;
  width: 1.2em;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .sidebar.menu {
    width: 280px !important;
  }
  
  .item {
    padding: 1em !important;
    font-size: 1.1em;
  }
}

/* Accessibility improvements */
.item:focus {
  outline: 2px solid #2185d0;
  outline-offset: -2px;
}

.item:focus:not(:focus-visible) {
  outline: none;
}

/* Dark mode support */
@media (prefers-color-scheme: dark) {
  .item:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  .item.active {
    background-color: rgba(255, 255, 255, 0.15);
  }
}
</style>